import { Action } from '@ngrx/store';

import { LatestVerificationConclusion, VerificationConclusion } from 'modules/shared/models/record.models';
import { VerificationConclusionsResponse, RecordOcrsResponse, RecordFaceComparesResponse } from 'store/models/record.models';
import { ApprovalStatus, RiskReport } from 'modules/shared/models/risk-assessment.models';
import {
  RiskReportResponse, RiskReportPayload, ApprovalStatusResponse, ApprovalStatusPayload,
  CreateApprovalStatusPayload, CreateRiskReportPayload,
} from 'store/models/risk-assessment.models';
import { ScreeningConclusion } from 'modules/shared/models/screening.models';

export enum RiskAssessmentActionTypes {
  GET_REPORTS = 'GET_REPORTS',
  GET_REPORTS_SUCCESS = 'GET_REPORTS_SUCCESS',
  GET_REPORTS_FAILURE = 'GET_REPORT_FAILURE',
  UPDATE_REPORT = 'UPDATE_REPORT',

  GET_OCR_RESULTS = 'GET_OCR_RESULTS',
  GET_OCR_RESULTS_SUCCESS = 'GET_OCR_RESULTS_SUCCESS',
  GET_OCR_RESULTS_FAILURE = 'GET_OCR_RESULTS_FAILURE',

  GET_FACE_RESULTS = 'GET_FACE_RESULTS',
  GET_FACE_RESULTS_SUCCESS = 'GET_FACE_RESULTS_SUCCESS',
  GET_FACE_RESULTS_FAILURE = 'GET_FACE_RESULTS_FAILURE',

  GET_CONCLUSIONS = 'GET_CONCLUSIONS',
  GET_OCR_CONCLUSIONS_SUCCESS = 'GET_OCR_CONCLUSIONS_SUCCESS',
  GET_FACE_CONCLUSIONS_SUCCESS = 'GET_FACE_CONCLUSIONS_SUCCESS',
  GET_CONCLUSIONS_FAILURE = 'GET_CONCLUSIONS_FAILURE',

  GET_LATEST_OCR_CONCLUSIONS = 'GET_LATEST_OCR_CONCLUSIONS',
  GET_LATEST_OCR_CONCLUSIONS_SUCCESS = 'GET_LATEST_OCR_CONCLUSIONS_SUCCESS',
  GET_LATEST_OCR_CONCLUSIONS_FAILURE = 'GET_LATEST_OCR_CONCLUSIONS_FAILURE',
  GET_LATEST_FACE_CONCLUSIONS = 'GET_LATEST_FACE_CONCLUSIONS',
  GET_LATEST_FACE_CONCLUSIONS_SUCCESS = 'GET_LATEST_FACE_CONCLUSIONS_SUCCESS',
  GET_LATEST_FACE_CONCLUSIONS_FAILURE = 'GET_LATEST_FACE_CONCLUSIONS_FAILURE',

  CREATE_SCREENING_CONCLUSION = 'CREATE_SCREENING_CONCLUSION',
  CREATE_SCREENING_CONCLUSION_SUCCESS = 'CREATE_SCREENING_CONCLUSION_SUCCESS',
  CREATE_SCREENING_CONCLUSION_FAILURE = 'CREATE_SCREENING_CONCLUSION_FAILURE',

  UPDATE_VERIFICATION_CONCLUSIONS = 'UPDATE_VERIFICATION_CONCLUSIONS',
  UPDATE_VERIFICATION_CONCLUSIONS_SUCCESS = 'UPDATE_VERIFICATION_CONCLUSIONS_SUCCESS',
  UPDATE_VERIFICATION_CONCLUSIONS_FAILURE = 'UPDATE_VERIFICATION_CONCLUSIONS_FAILURE',

  GET_APPROVAL_STATUS = 'GET_APPROVAL_STATUS',
  GET_APPROVAL_STATUS_SUCCESS = 'GET_APPROVAL_STATUS_SUCCESS',
  GET_APPROVAL_STATUS_FAILURE = 'GET_APPROVAL_STATUS_FAILURE',

  CREATE_APPROVAL_STATUS = 'CREATE_APPROVAL_STATUS',
  CREATE_APPROVAL_STATUS_SUCCESS = 'CREATE_APPROVAL_STATUS_SUCCESS',
  CREATE_APPROVAL_STATUS_FAILURE = 'CREATE_APPROVAL_STATUS_FAILURE',

  CREATE_RISK_REPORT = 'CREATE_RISK_REPORT',
  CREATE_RISK_REPORT_SUCCESS = 'CREATE_RISK_REPORT_SUCCESS',
  CREATE_RISK_REPORT_FAILURE = 'CREATE_RISK_REPORT_FAILURE',
}

export class GetReports implements Action {
  readonly type: RiskAssessmentActionTypes =
    RiskAssessmentActionTypes.GET_REPORTS;
  constructor(public payload?: RiskReportPayload) { }
}

export class GetReportsSuccess implements Action {
  readonly type: RiskAssessmentActionTypes =
    RiskAssessmentActionTypes.GET_REPORTS_SUCCESS;
  constructor(public payload: RiskReportResponse = null) { }
}

export class GetReportsFailure implements Action {
  readonly type: RiskAssessmentActionTypes =
    RiskAssessmentActionTypes.GET_REPORTS_FAILURE;
  constructor(public payload: any = null) { }
}

export class UpdateReport implements Action {
  readonly type: RiskAssessmentActionTypes =
    RiskAssessmentActionTypes.UPDATE_REPORT;
  constructor(public payload: RiskReport = null) { }
}

export class GetOcrResults implements Action {
  readonly type: RiskAssessmentActionTypes =
    RiskAssessmentActionTypes.GET_OCR_RESULTS;
  constructor(public payload?: any) { }
}

export class GetOcrResultsSuccess implements Action {
  readonly type: RiskAssessmentActionTypes =
    RiskAssessmentActionTypes.GET_OCR_RESULTS_SUCCESS;
  constructor(public payload: RecordOcrsResponse = null) { }
}

export class GetOcrResultsFailure implements Action {
  readonly type: RiskAssessmentActionTypes =
    RiskAssessmentActionTypes.GET_OCR_RESULTS_FAILURE;
  constructor(public payload: any = null) { }
}

export class GetFaceResults implements Action {
  readonly type: RiskAssessmentActionTypes =
    RiskAssessmentActionTypes.GET_FACE_RESULTS;
  constructor(public payload?: any) { }
}

export class GetFaceResultsSuccess implements Action {
  readonly type: RiskAssessmentActionTypes =
    RiskAssessmentActionTypes.GET_FACE_RESULTS_SUCCESS;
  constructor(public payload: RecordFaceComparesResponse = null) { }
}

export class GetFaceResultsFailure implements Action {
  readonly type: RiskAssessmentActionTypes =
    RiskAssessmentActionTypes.GET_FACE_RESULTS_FAILURE;
  constructor(public payload: any = null) { }
}

export class GetConclusions implements Action {
  readonly type: RiskAssessmentActionTypes =
    RiskAssessmentActionTypes.GET_CONCLUSIONS;
  constructor(public payload?: any) { }
}

export class GetOcrConclusionSuccess implements Action {
  readonly type: RiskAssessmentActionTypes =
    RiskAssessmentActionTypes.GET_OCR_CONCLUSIONS_SUCCESS;
  constructor(public payload: VerificationConclusionsResponse = null) { }
}

export class GetFaceConclusionSuccess implements Action {
  readonly type: RiskAssessmentActionTypes =
    RiskAssessmentActionTypes.GET_FACE_CONCLUSIONS_SUCCESS;
  constructor(public payload: VerificationConclusionsResponse = null) { }
}

export class GetConclusionsFailure implements Action {
  readonly type: RiskAssessmentActionTypes =
    RiskAssessmentActionTypes.GET_CONCLUSIONS_FAILURE;
  constructor(public payload: any = null) { }
}

export class GetLatestOcrConclusions implements Action {
  readonly type: RiskAssessmentActionTypes =
    RiskAssessmentActionTypes.GET_LATEST_OCR_CONCLUSIONS;
  constructor(public payload?: any) { }
}

export class GetLatestOcrConclusionSuccess implements Action {
  readonly type: RiskAssessmentActionTypes =
    RiskAssessmentActionTypes.GET_LATEST_OCR_CONCLUSIONS_SUCCESS;
  constructor(public payload: LatestVerificationConclusion = null) { }
}

export class GetLatestOcrConclusionFailure implements Action {
  readonly type: RiskAssessmentActionTypes =
    RiskAssessmentActionTypes.GET_LATEST_OCR_CONCLUSIONS_FAILURE;
  constructor(public payload: any = null) { }
}

export class GetLatestFaceConclusions implements Action {
  readonly type: RiskAssessmentActionTypes =
    RiskAssessmentActionTypes.GET_LATEST_FACE_CONCLUSIONS;
  constructor(public payload?: any) { }
}

export class GetLatestFaceConclusionSuccess implements Action {
  readonly type: RiskAssessmentActionTypes =
    RiskAssessmentActionTypes.GET_LATEST_FACE_CONCLUSIONS_SUCCESS;
  constructor(public payload: LatestVerificationConclusion = null) { }
}

export class GetLatestFaceConclusionFailure implements Action {
  readonly type: RiskAssessmentActionTypes =
    RiskAssessmentActionTypes.GET_LATEST_FACE_CONCLUSIONS_FAILURE;
  constructor(public payload: any = null) { }
}

export class CreateScreeningConclusion implements Action {
  readonly type: RiskAssessmentActionTypes =
    RiskAssessmentActionTypes.CREATE_SCREENING_CONCLUSION;
  constructor(public payload?: any) { }
}

export class CreateScreeningConclusionSuccess implements Action {
  readonly type: RiskAssessmentActionTypes =
    RiskAssessmentActionTypes.CREATE_SCREENING_CONCLUSION_SUCCESS;
  constructor(public payload: ScreeningConclusion = null) { }
}

export class CreateScreeningConclusionFailure implements Action {
  readonly type: RiskAssessmentActionTypes =
    RiskAssessmentActionTypes.CREATE_SCREENING_CONCLUSION_FAILURE;
  constructor(public payload: any = null) { }
}

export class UpdateVerificationConclusion implements Action {
  readonly type: RiskAssessmentActionTypes =
    RiskAssessmentActionTypes.UPDATE_VERIFICATION_CONCLUSIONS;
  constructor(public payload?: any) { }
}

export class UpdateVerificationConclusionSuccess implements Action {
  readonly type: RiskAssessmentActionTypes =
    RiskAssessmentActionTypes.UPDATE_VERIFICATION_CONCLUSIONS_SUCCESS;
  constructor(public payload: VerificationConclusion = null) { }
}

export class UpdateVerificationConclusionFailure implements Action {
  readonly type: RiskAssessmentActionTypes =
    RiskAssessmentActionTypes.UPDATE_VERIFICATION_CONCLUSIONS_FAILURE;
  constructor(public payload: any = null) { }
}

export class GetApprovalStatus implements Action {
  readonly type: RiskAssessmentActionTypes =
    RiskAssessmentActionTypes.GET_APPROVAL_STATUS;
  constructor(public payload?: ApprovalStatusPayload) { }
}

export class GetApprovalStatusSuccess implements Action {
  readonly type: RiskAssessmentActionTypes =
    RiskAssessmentActionTypes.GET_APPROVAL_STATUS_SUCCESS;
  constructor(public payload: ApprovalStatusResponse = null) { }
}


export class GetApprovalStatusFailure implements Action {
  readonly type: RiskAssessmentActionTypes =
    RiskAssessmentActionTypes.GET_APPROVAL_STATUS_FAILURE;
  constructor(public payload: any = null) { }
}

export class CreateApprovalStatus implements Action {
  readonly type: RiskAssessmentActionTypes =
    RiskAssessmentActionTypes.CREATE_APPROVAL_STATUS;
  constructor(public payload?: CreateApprovalStatusPayload) { }
}

export class CreateApprovalStatusSuccess implements Action {
  readonly type: RiskAssessmentActionTypes =
    RiskAssessmentActionTypes.CREATE_APPROVAL_STATUS_SUCCESS;
  constructor(public payload: ApprovalStatus = null) { }
}

export class CreateRiskReport implements Action {
  readonly type: RiskAssessmentActionTypes =
    RiskAssessmentActionTypes.CREATE_RISK_REPORT;
  constructor(public payload: CreateRiskReportPayload = null) { }
}

export class CreateRiskReportSuccess implements Action {
  readonly type: RiskAssessmentActionTypes =
    RiskAssessmentActionTypes.CREATE_RISK_REPORT_SUCCESS;
  constructor(public payload: RiskReport = null) { }
}

export class CreateRiskReportFailure implements Action {
  readonly type: RiskAssessmentActionTypes =
    RiskAssessmentActionTypes.CREATE_RISK_REPORT_FAILURE;
  constructor(public payload: any = null) { }
}

export class CreateApprovalStatusFailure implements Action {
  readonly type: RiskAssessmentActionTypes =
    RiskAssessmentActionTypes.CREATE_APPROVAL_STATUS_FAILURE;
  constructor(public payload: any = null) { }
}

export type RiskAssessmentActions =
  | GetReports
  | GetReportsSuccess
  | GetReportsFailure
  | GetOcrResults
  | GetOcrResultsSuccess
  | GetOcrResultsFailure
  | GetFaceResults
  | GetFaceResultsSuccess
  | GetFaceResultsFailure
  | GetConclusions
  | GetConclusionsFailure
  | GetOcrConclusionSuccess
  | GetLatestOcrConclusions
  | GetLatestOcrConclusionSuccess
  | GetLatestOcrConclusionFailure
  | GetFaceConclusionSuccess
  | GetLatestFaceConclusions
  | GetLatestFaceConclusionSuccess
  | GetLatestFaceConclusionFailure
  | CreateScreeningConclusion
  | CreateScreeningConclusionSuccess
  | CreateScreeningConclusionFailure
  | UpdateVerificationConclusion
  | UpdateVerificationConclusionSuccess
  | UpdateVerificationConclusionFailure
  | GetApprovalStatus
  | GetApprovalStatusSuccess
  | GetApprovalStatusFailure
  | CreateApprovalStatus
  | CreateApprovalStatusSuccess
  | CreateApprovalStatusFailure
  | CreateRiskReport
  | CreateRiskReportSuccess
  | CreateRiskReportFailure;
